import { Page } from 'editor/src/store/design/types';

const isPagePrintable = (page: Page) => Boolean(page.groups.mediabox?.length) && Boolean(page.groups.content?.length);

export default isPagePrintable;
